<template>
	<div class="full">
	 <div class="rank flex-center-between" v-for="(item, i) in bitDataList" :key="i" @click="chooseBit(item)">
			<div class="flex-3 flex-center-start">
				<div class="icon" :class="item.ShortName == 'BAL' ? 'bg' : ''">
					<img :src="`/upload/${item.Logo}` || usdtUrl" alt="">
				</div>
				<div class="name">
					<div>{{item.ShortName}}</div>
					<div class="gray">{{item.Name}}</div>
				</div>
			</div>
			<div class="flex-2 text-right count">{{item.count}}</div>
			<div class="flex-2 text-right " >
				<div class="percent" :class="!item.percent || item.percent >= 0 ? 'green' : 'red'">
					{{item.percent && item.percent > 0 ? '+' : ''}}{{item.percent !== undefined ? `${item.percent}%` : '--'}}
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { initWebSocket } from '@/utils/common'
export default {
	data() {
		return {
			usdtUrl: require('../../assets/imgs/icon-usdt.png'),
			bitDataList: []
		}
	},
	props: {
		dataList: Array,
		subscribe: Boolean
	},
	computed: {
  },
	watch: {
		dataList(val) {
			if (val) {
				this.bitDataList = this.dataList.filter(v => {
					return v.ShortName != 'USDT'
				})
			}
		}
	},
	mounted() {
		this.bitDataList = this.dataList.filter(v => {
			return v.ShortName != 'USDT' || v.ShortName != "WBTC"
		})
	},
	methods: {
   
		chooseBit(data) {
			this.$emit('detail', data)
		}
	}
}
</script>